/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "azure-devops-ui/Ago", "azure-devops-ui/Card", "azure-devops-ui/Core/Observable", "azure-devops-ui/Status", "azure-devops-ui/Table", "azure-devops-ui/TooltipEx", "azure-devops-ui/Utilities/Provider", "react", "../../Resources", "../Common/KubeCardWithTable", "../Common/KubeZeroData", "../FluxCommon/ActionsCreatorManager", "../Selection/SelectionActionCreator", "../Utils", "./ServiceUtils", "./ServiceDetails.scss"], function (require, exports, Ago_1, Card_1, Observable_1, Status_1, Table_1, TooltipEx_1, Provider_1, React, Resources, KubeCardWithTable_1, KubeZeroData_1, ActionsCreatorManager_1, SelectionActionCreator_1, Utils_1, ServiceUtils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var loadBalancerKey = "LoadBalancer";
    var ServicesTable = /** @class */ (function (_super) {
        __extends(ServicesTable, _super);
        function ServicesTable(props) {
            var _this = _super.call(this, props, {}) || this;
            _this._openServiceItem = function (event, tableRow, selectedItem) {
                if (selectedItem) {
                    var payload = {
                        item: selectedItem,
                        itemUID: selectedItem.service.metadata.uid,
                        showSelectedItem: true,
                        selectedItemType: "service-item" /* ServiceItemKey */
                    };
                    _this._selectionActionCreator.selectItem(payload);
                }
            };
            _this._getColumns = function () {
                var columns = [];
                // negative widths are interpreted as percentages.
                // since we want the table columns to occupy full available width, setting width - 100 which is equivalent to 100 %
                columns.push({
                    id: "package",
                    name: Resources.NameText,
                    width: -70,
                    renderCell: _this._renderPackageKeyCell
                });
                columns.push({
                    id: "clusterIP",
                    name: Resources.ClusterIPText,
                    width: -15,
                    renderCell: Table_1.renderSimpleCell
                });
                columns.push({
                    id: "externalIP",
                    name: Resources.ExternalIPText,
                    width: new Observable_1.ObservableValue(172),
                    renderCell: function (rowIndex, columnIndex, tableColumn, service) { return KubeCardWithTable_1.renderExternalIpCell(rowIndex, columnIndex, tableColumn, service, _this._setCopiedRowIndex); }
                });
                columns.push({
                    id: "port",
                    name: Resources.PortText,
                    width: new Observable_1.ObservableValue(200),
                    renderCell: Table_1.renderSimpleCell
                });
                columns.push({
                    id: "creationTimestamp",
                    name: Resources.AgeText,
                    width: -15,
                    renderCell: _this._renderAgeCell
                });
                return columns;
            };
            _this._renderPackageKeyCell = function (rowIndex, columnIndex, tableColumn, service) {
                return ServicesTable._getServiceStatusWithName(service, columnIndex, tableColumn);
            };
            _this._renderAgeCell = function (rowIndex, columnIndex, tableColumn, service) {
                var itemToRender = React.createElement(Ago_1.Ago, { className: "body-m", date: new Date(service.creationTimestamp) });
                return KubeCardWithTable_1.renderTableCell(rowIndex, columnIndex, tableColumn, itemToRender);
            };
            _this._setCopiedRowIndex = function (copiedRowIndex) {
                _this.setState({
                    copiedRowIndex: copiedRowIndex
                });
            };
            _this.state = {
                copiedRowIndex: -1
            };
            _this._selectionActionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(SelectionActionCreator_1.SelectionActionsCreator);
            return _this;
        }
        ServicesTable.prototype.render = function () {
            var _this = this;
            var filteredSvc = (this.props.serviceList && this.props.serviceList.items || [])
                .filter(function (svc) {
                return _this._filterService(svc);
            });
            if (filteredSvc.length > 0) {
                var serviceItems_1 = ServiceUtils_1.getServiceItems(filteredSvc).map(function (item, index) { item.externalIPTooltip = index === _this.state.copiedRowIndex ? Resources.CopiedExternalIp : Resources.CopyExternalIp; return item; });
                var tableProps = {
                    id: "services-list-table",
                    showHeader: true,
                    showLines: true,
                    singleClickActivation: true,
                    itemProvider: new Provider_1.ArrayItemProvider(serviceItems_1),
                    ariaLabel: Resources.PivotServiceText,
                    columns: this._getColumns(),
                    onActivate: function (event, tableRow) {
                        _this._openServiceItem(event, tableRow, serviceItems_1[tableRow.index]);
                    }
                };
                return (React.createElement(Card_1.Card, { className: "services-list-card flex-grow bolt-table-card bolt-card-no-vertical-padding", contentProps: { contentPadding: false } },
                    React.createElement(Table_1.Table, __assign({}, tableProps))));
            }
            else {
                return KubeZeroData_1.KubeZeroData.getNoResultsZeroData();
            }
        };
        ServicesTable.prototype.componentDidMount = function () {
            this.props.markTTICallback && this.props.markTTICallback();
        };
        ServicesTable._getServiceStatusWithName = function (service, columnIndex, tableColumn) {
            var statusProps = Status_1.Statuses.Success;
            var tooltipText = "";
            if (service.type === loadBalancerKey) {
                tooltipText = Resources.ExternalIPAllocated;
                if (!service.externalIP) {
                    tooltipText = Resources.ExternalIPAllocPending;
                    statusProps = Status_1.Statuses.Running;
                }
            }
            return (React.createElement(Table_1.TwoLineTableCell, { key: "col-" + columnIndex, columnIndex: columnIndex, tableColumn: tableColumn, line1: React.createElement(TooltipEx_1.Tooltip, { overflowOnly: true, text: service.package },
                    React.createElement("div", { className: "body-m font-weight-semibold text-ellipsis" }, service.package)), line2: React.createElement("div", { className: "body-s secondary-text text-ellipsis" }, service.type), iconProps: {
                    render: function (className) {
                        return (React.createElement(TooltipEx_1.Tooltip, { text: tooltipText },
                            React.createElement("div", { className: "flex-row" },
                                React.createElement(Status_1.Status, __assign({}, statusProps, { ariaLabel: tooltipText, className: "icon-large-margin", size: "24" /* l */ })))));
                    }
                } }));
        };
        ServicesTable.prototype._filterService = function (svc) {
            var nameMatches = Utils_1.Utils.filterByName(svc.metadata.name, this.props.nameFilter);
            var typeMatches = this.props.typeSelections.length > 0 ? this.props.typeSelections.indexOf(svc.spec.type) >= 0 : true;
            return nameMatches && typeMatches;
        };
        return ServicesTable;
    }(React.Component));
    exports.ServicesTable = ServicesTable;
});
